module.exports = __webpack_public_path__ + "img/logo.379136bc.svg";